/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type { OrderRetrievePathId, OrderRetrieveStatus200 } from "../types/OrderRetrieve.ts";
import type { QueryKey, QueryClient, UseQueryOptions, UseQueryReturnType } from "@tanstack/vue-query";
import type { MaybeRefOrGetter } from "vue";
import { orderRetrieve } from "../requests/orderRetrieve.ts";
import { queryOptions, useQuery } from "@tanstack/vue-query";
import { toValue } from "vue";

export const orderRetrieveQueryKey = (id?: MaybeRefOrGetter<OrderRetrievePathId>) => [{ url: "/api/order/:id/", params: { id: id } }] as const;

export type OrderRetrieveQueryKey = ReturnType<typeof orderRetrieveQueryKey>;

export function orderRetrieveQueryOptions(id?: MaybeRefOrGetter<OrderRetrievePathId>, config: Partial<RequestConfig> & { client?: Client } = {}) {
	const queryKey = orderRetrieveQueryKey(id);
	return queryOptions<OrderRetrieveStatus200, ResponseErrorConfig<Error>, OrderRetrieveStatus200>({
		enabled: () => !!toValue(id),
		queryKey,
		queryFn: async ({ signal }) => {
			return orderRetrieve(toValue(id!), { ...config, signal: config.signal ?? signal });
		},
	});
}

/**
 * @description Миксин формирования сложного запроса для
 * объекта/списка объектов заказа через сайт.
 * {@link /api/order/:id/}
 */
export function useOrderRetrieve<TData = OrderRetrieveStatus200, TQueryData = OrderRetrieveStatus200, TQueryKey extends QueryKey = OrderRetrieveQueryKey>(
	id?: MaybeRefOrGetter<OrderRetrievePathId>,
	options: {
		query?: Partial<UseQueryOptions<OrderRetrieveStatus200, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient };
		client?: Partial<RequestConfig> & { client?: Client };
	} = {},
) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const queryKey = (resolvedOptions && "queryKey" in resolvedOptions ? toValue(resolvedOptions.queryKey) : undefined) ?? orderRetrieveQueryKey(id);

	const query = useQuery(
		{
			...orderRetrieveQueryOptions(id, config),
			...resolvedOptions,
			queryKey,
		} as unknown as UseQueryOptions<OrderRetrieveStatus200, ResponseErrorConfig<Error>, TData, OrderRetrieveStatus200, TQueryKey>,
		toValue(queryClient),
	) as UseQueryReturnType<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

	query.queryKey = queryKey as TQueryKey;

	return query;
}
